import { useDezoomPulse } from '../../hooks/useDezoomPulse';
import type { CropMeta } from '../../utils/cropUtils';

interface LiveCropViewProps {
  originalUrl: string;
  crop: CropMeta;
  imgW: number;
  imgH: number;
  activeLevel?: number;
}

/** Affiche exactement la zone cropée sur l'original (comme l'éditeur admin). */
export function LiveCropView({ originalUrl, crop, imgW, imgH, activeLevel = 0 }: LiveCropViewProps) {
  const dezooming = useDezoomPulse(activeLevel);
  const bgW = (imgW / crop.width) * 100;
  const bgH = (imgH / crop.height) * 100;
  const posX = imgW > crop.width ? (crop.left / (imgW - crop.width)) * 100 : 50;
  const posY = imgH > crop.height ? (crop.top / (imgH - crop.height)) * 100 : 50;

  return (
    <div className={`zoom-frame${dezooming ? ' is-dezooming' : ''}`}>
      <div
        className={`live-crop-view${dezooming ? ' is-dezooming' : ''}`}
        style={{
          backgroundImage: `url(${originalUrl})`,
          backgroundSize: `${bgW}% ${bgH}%`,
          backgroundPosition: `${Number.isFinite(posX) ? posX : 50}% ${Number.isFinite(posY) ? posY : 50}%`,
        }}
        role="img"
        aria-label="Crop preview"
      />
    </div>
  );
}
